<template>
    <v-app v-if="dialogShow || isConnectionLostShow">
        <v-container>

            <v-row v-if="dialogShow">
                <wait-status-dialog
                        :show="isDialogOpened"
                        :loading="isLoading"
                        @onShowChange="(s) => isDialogOpened = s"
                        :closable="!(isLoading || isNotClosable)"
                        @outsideClick="outsideClick"
                        :width="width"
                >
                    <v-card style="border: none ;box-shadow: none">

                        <v-card-text class="text-center d-flex flex-column justify-center align-center p-0">
                            <div class="d-flex justify-content-end mt-1 ml-3 mr-2 mb-0 w-100" v-if="!isNotClosable">
                                <img
                                        class="closeBtn"
                                        src="/media/svg/icons/Navigation/Close.svg"
                                        @click="closeDialog()"
                                >
                            </div>
                            <div
                                    class="d-flex justify-center mb-3 mx-auto"
                            >
                                <v-img
                                        :src="getIcon"
                                        max-height="80"
                                        max-width="80"
                                        contain
                                />
                            </div>

                            <p class="font-weight-bold font-size-h4 mt-2">
                                {{ title }}
                            </p>

                            <p class="mx-3 line-height-xl" style="font-size: 9pt" v-if="description">
                                {{ description }}
                            </p>

                            <v-textarea
                                    v-if="getData"
                                    v-model="getData"
                                    class="mt-0 pt-1 mb-0 pb-0 mx-2 w-100"
                                    readonly
                                    hide-details
                            ></v-textarea>

                        </v-card-text>

                        <v-list dense v-if="actionButtons.length" class="pb-2 pb-0 mt-2 pt-0">

                            <v-list-item-group
                                    color="primary"
                            >
                                <v-list-item
                                        dense
                                        v-for="(item, i) in actionButtons"
                                        :key="i"
                                        :class="['mx-5', item.class ? item.class : '']"
                                        @click="clickOnActions(item)"
                                >
                                    <div :class="['d-flex flex-column w-100 px-0 py-0']">
                                        <div class="d-flex text-right flex-row flex-nowrap pb-0 mb-0"
                                             style="color: #1c0152">
                                            <v-list-item-icon class="m-0">
                                                <v-icon style="font-size: 10pt;color: #1c0152"
                                                        v-text="item.icon? item.icon : 'mdi-circle-small'"></v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content
                                                    class="ms-2"
                                            >
                                                <v-list-item-title v-text="item.text"
                                                                   style="margin-top: -0.2rem;font-weight: bolder"></v-list-item-title>
                                            </v-list-item-content>
                                        </div>
                                    </div>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>

                        <div class="d-flex flex-wrap justify-content-center align-center w-100 px-2 pb-5">
                            <v-btn
                                    v-for="b in primaryButtons"
                                    :color="b.color"
                                    :class="['mx-2', 'mt-5', 'mb-0' , b.class?b.class:'', 'text-white']"
                                    @click="clickOnActions(b)"
                            >
                                {{ b.text }}
                            </v-btn>
                        </div>
                    </v-card>

                </wait-status-dialog>

            </v-row>
            <v-row v-if="isConnectionLostShow">
                <v-dialog
                        v-model='isLostShow'
                        :width="200"
                        persistent
                >

                    <v-card style="position: fixed; right: 0; top:0; width: 20rem" class="m-3 pb-0 p-2">

                        <v-card-text class="text-center d-flex justify-center align-items-center p-0 mb-0 pr-2">

                            <atom-spinner
                                    :animation-duration="2000"
                                    :size="40"
                                    color="indigo"
                            />
                            <div class="d-flex flex-column justify-center w-75">
                                {{ getConnectionLostTitle }}
                                <v-btn text color="primary" @click="(getConnectionLostButtonAction)()">
                                    {{ getConnectionLostButtonText }}
                                </v-btn>
                            </div>

                        </v-card-text>
                    </v-card>

                </v-dialog>
            </v-row>

        </v-container>
    </v-app>

</template>

<script>
import vx from './store/index'
import WaitStatusDialog from './components/dialogs/WaitStatusDialog'
import {
    Showing,
    Closable,
    Loading,
    Title,
    Description,
    PrimaryButtons,
    Events,
    Width,
    ActionButtons,
    Data,
    Icon
} from "@/core/plugins/EasyModal/store/global";
import {FulfillingBouncingCircleSpinner} from 'epic-spinners'
import {SemipolarSpinner} from 'epic-spinners'
import {AtomSpinner} from 'epic-spinners'

export default {
    name: "viewEasyModal",
    components: {WaitStatusDialog, FulfillingBouncingCircleSpinner, AtomSpinner, SemipolarSpinner},
    data() {
        return {
            isDialogOpened: false,
            isLostShow: false,
        }
    },
    created() {

    },
    computed: {
        dialogShow() {
            this.isDialogOpened = vx.getters.isShow;
            return vx.getters.isShow
        },
        isLoading() {
            return vx.getters[Loading]
        },
        isNotClosable() {
            return vx.getters[Closable]
        },
        title() {
            return vx.getters[Title];
        },
        description() {
            return vx.getters[Description];
        },
        primaryButtons() {
            return vx.getters[PrimaryButtons];
        },
        onClose() {
            return vx.getters[Events.Close]
        },
        width() {
            return vx.getters[Width]
        },
        actionButtons() {
            return vx.getters[ActionButtons]
        },
        getData() {
            return vx.getters[Data];
        },
        getIcon() {
            return vx.getters[Icon];
        },
        isConnectionLostShow() {
            this.isLostShow = vx.getters['connectionLost/isShow'];
            return this.isLostShow;
        },
        getConnectionLostTitle() {
            return vx.getters['connectionLost/title'];
        },
        getConnectionLostButtonText() {
            return vx.getters['connectionLost/button'];
        },
        getConnectionLostButtonAction() {
            return vx.getters['connectionLost/onClick'];
        },
    },
    watch: {
        isDialogOpened() {
            vx.dispatch(Showing, this.isDialogOpened)
        },
        isLostShow() {
            vx.dispatch("connectionLost/show", this.showing)
        }
    },
    methods: {
        closeDialog(byUser = true) {
            vx.dispatch(Showing, false)
            if (byUser && this.onClose) {
                (this.onClose)();
            }
        },
        runButtonEvent(event) {
            if (event) {
                event();
            }
            this.closeDialog(false);
        },
        outsideClick() {
            if (!this.isNotClosable) {
                this.closeDialog();
            }
        },
        clickOnActions(item) {
            if (item.closeOnClick ?? true) {
                this.closeDialog();
            }
            if (item.onClick) {
                item.onClick();
            }
        }
    }
}
</script>

<style scoped>
.dialog {
    /*position: fixed;*/
    /*left: -1000rem;*/
    /*top: 0;*/
    /*overflow: hidden;*/
    /*width: 0;*/
    /*height: 0.01rem;*/
}

.closeBtn {
    cursor: pointer;
}

.actionBackgroundGray {
    background-color: rgba(169, 169, 169, 0.1);
}

.actionBorderBottom {
    border-top: 0.5px gray dotted;
}
</style>